import { Component } from "@/types"
import { cx } from "@/utils/cx"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Title } from "@/ui/atoms/type/Title"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Grid } from "@/ui/atoms/layout/Grid"
import { Image } from "@/ui/atoms/media/Image"

export const COMPONENT_NAME = "courseOverview"

export const presets = {}

export interface Props extends Component {}

export function CourseOverview({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(className)} data-test={testId}>
      <MarketingSection>
        <Grid className="gap-y-12 lg:gap-x-12">
          {/* Content */}
          <Stack className="col-span-full row-start-1 md:col-span-5 md:col-start-8 md:row-start-1 justify-center gap-4">
            <Title size="xl">
              SANS Foundations is the most comprehensive, certified introductory cybersecurity
              course, on the market.
            </Title>
            <BodyText size="lg" className="text-text-subtle font-light lg:text-[18px]">
              The course is created by experts, perfectly balanced between interactive learning,
              hands-on labs, and practical exercises across 13 cyber-specialist areas, going far
              beyond what is offered by any other foundational cybersecurity course.
            </BodyText>
          </Stack>
          {/* Image */}
          <Stack className="col-span-full row-start-2 md:col-start-1 md:col-span-6 md:row-start-1 justify-center">
            <Image
              src="/content/marketing/course-dashboard.webp"
              alt="Course Overview"
              height={1029}
              width={1000}
              className="rounded-lg drop-shadow overflow-hidden"
            />
          </Stack>
        </Grid>
      </MarketingSection>
    </div>
  )
}
